/**
 * Nullthrows is useful: https://www.notion.so/withpersona/nullthrows-0c34602159a7432993afdfe2b2830abe
 */
export function nullthrows<T>(value: T | null | undefined, msg?: string): T {
  if (value == null) {
    throw new Error(msg ?? 'nullthrows: unexpected null or undefined');
  }
  return value;
}
